import styled from 'styled-components';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { FieldSet, Form } from 'components/Form';

export const RadioForm = styled(Form)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
`;

export const RadioGroup = styled(FieldSet)`
  grid-column: 1 / 4;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  align-content: start;
  align-items: start;

  && > * + * {
    margin-top: 0;
  }
`;

export const RadioWrapper = styled.label`
  display: flex;
  align-items: start;
  gap: 0.25rem;

  &&:hover {
    cursor: pointer;
  }
`;

export const RadioInput = styled.input.attrs({ type: 'radio' })`
  font-size: 14px;
  margin: 0;
  accent-color: ${({ theme }) => theme.colorActionPrimaryDefault};

  &&:focus-visible,
  &&:focus {
    outline: Highlight solid 2px;
    outline: -webkit-focus-ring-color auto 1px;
  }
`;

export const RadioLabel = styled(Paragraph).attrs({
  as: 'span',
  typography: 'ParagraphTinyRegular',
})``;
